var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTranslation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9332 24.46L18.3805 21.875L18.4102 21.8438C20.1599 19.8463 21.4059 17.5512 22.1397 15.1213H25.0859V13.0587H18.0477V11H16.0369V13.0587H9V15.1075H20.2304C19.5511 17.095 18.4907 18.9775 17.0429 20.625C16.1075 19.56 15.3341 18.4012 14.7204 17.1762H12.7096C13.4434 18.855 14.4494 20.4388 15.7053 21.87L10.5937 27.0438L12.0167 28.5L17.0429 23.3525L20.1698 26.555L20.9332 24.46Z",
    fill: "#006AED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7166 18.5L31.2726 31H29.2483L28.1099 27.875H23.3002L22.1618 31H20.1362L24.6922 18.5H26.7166ZM25.7044 21.275L24.0587 25.7913H27.3501L25.7044 21.2762V21.275Z",
    fill: "#006AED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.9117baf8f4ec404a392be97571f5bb09.svg";
export { ForwardRef as ReactComponent };